module.exports = __webpack_public_path__ + "assets/img/shouquan.60bfd48f.png";